import React from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import GenerateForm from "../../../Components/formElements/GenerateQuestionaries/GenerateForm";

const AddFormModal = React.forwardRef((props, ref) => {
  const { onSave, onCancel, formType } = props.modeldata || {};

  // Handle form OK - just close, the save is handled by GenerateForm
  const okConfirm = async () => {
    if (onCancel) {
      onCancel();
    }
    props.onHide();
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      ref={ref}
      dialogClassName="modal-90w"
      size="xl"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <i className="bi bi-add"></i>
          <span className="modal-title"> Add Form </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modalSection">
        <Row>
          <Col xs={12} md={12} lg={12} className="commLeftRightPadding">
            <GenerateForm
              formType={formType}
              onSave={onSave}
              onCancel={okConfirm}
            />
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
});

export default AddFormModal;